import React from "react";
import { Main, Menu, Nav } from "@dpdgroupuk/mydpd-ui";
import { NavLink } from "react-router-dom";
import { StringUtil } from "../../utils";

const Third = ({
  onSelect,
  items
}) => {
  return /*#__PURE__*/React.createElement(Main, null, /*#__PURE__*/React.createElement(Main.Header, null, /*#__PURE__*/React.createElement(Menu.Third, {
    navbar: true,
    onSelect: onSelect
  }, items.map((link, index) => {
    const to = link.href || link.to;
    const name = link.name;
    return StringUtil.isAbsoluteHref(to) ? /*#__PURE__*/React.createElement(Nav.Link, {
      key: index,
      href: to
    }, name) : /*#__PURE__*/React.createElement(Nav.Link, {
      as: NavLink,
      key: index,
      to: to
    }, name);
  }))));
};

Third.propTypes = Menu.Third.propTypes;
export default Third;